export * from "/__w/wiggot-web/wiggot-web/packages/web-components/store/modals/modal-delete-property.store.ts"